var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHeadphone = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 21,
  height: 19,
  viewBox: "0 0 21 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1218_1852)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.67676 14.8109V9.22269C1.67676 6.99955 2.5599 4.86746 4.13189 3.29547C5.70389 1.72347 7.83597 0.840332 10.0591 0.840332C12.2822 0.840332 14.4143 1.72347 15.9863 3.29547C17.5583 4.86746 18.4415 6.99955 18.4415 9.22269V14.8109",
  stroke: "#333333",
  strokeWidth: 1.45294,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.4415 15.7423C18.4415 16.2363 18.2452 16.7101 17.8959 17.0595C17.5465 17.4088 17.0727 17.6051 16.5787 17.6051H15.6473C15.1533 17.6051 14.6795 17.4088 14.3302 17.0595C13.9809 16.7101 13.7846 16.2363 13.7846 15.7423V12.9482C13.7846 12.4542 13.9809 11.9804 14.3302 11.631C14.6795 11.2817 15.1533 11.0854 15.6473 11.0854H18.4415V15.7423ZM1.67676 15.7423C1.67676 16.2363 1.87301 16.7101 2.22234 17.0595C2.57168 17.4088 3.04547 17.6051 3.5395 17.6051H4.47088C4.96491 17.6051 5.4387 17.4088 5.78804 17.0595C6.13737 16.7101 6.33362 16.2363 6.33362 15.7423V12.9482C6.33362 12.4542 6.13737 11.9804 5.78804 11.631C5.4387 11.2817 4.96491 11.0854 4.47088 11.0854H1.67676V15.7423Z",
  stroke: "#333333",
  strokeWidth: 1.45294,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1218_1852"
}, /*#__PURE__*/React.createElement("rect", {
  width: 20.1176,
  height: 19,
  fill: "white"
})))));
export default SvgHeadphone;